// Login functions
// Handles email/password authentication

import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getAuth } from '../firebase/config';
import { logAuth } from '../utils/audit';

interface LoginParams {
  email: string;
  password: string;
}

interface LoginResult {
  success: boolean;
  error?: string;
}

/**
 * Signs in a user with email/password
 */
export async function loginWithEmail({ email, password }: LoginParams): Promise<LoginResult> {
  try {
    const auth = getAuth();
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Log login action (organizationId will be loaded from user document)
    // We'll log it after user document is loaded in AuthProvider
    await logAuth(user.uid, '', 'login', { email });

    return {
      success: true,
    };
  } catch (error) {
    console.error('Login error:', error);
    return {
      success: false,
      error: (error as Error).message,
    };
  }
}

/**
 * Signs out the current user
 */
export async function logout(): Promise<void> {
  const auth = getAuth();
  const user = auth.currentUser;
  
  if (user) {
    // Log logout before signing out
    // Note: We might not have organizationId here, but that's okay
    try {
      await logAuth(user.uid, '', 'logout', {});
    } catch (err) {
      console.error('Failed to log logout action:', err);
    }
  }
  
  await signOut(auth);
}

